import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Slider } from "@material-ui/core";
export const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#F6F7FB",
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: 10,
    // color: theme.palette.text.secondary,
  },
  container: {
    marginTop: 30,
  },
  heading: {
    fontSize: 18,
    fontWeight: 700,
    textAlign: "left",
    textTransform: "uppercase",
    marginBottom: 30,
  },
  heading2: {
    fontSize: 25,
    fontWeight: 700,
    textAlign: "left",
    marginBottom: 12,
  },
  text: {
    textAlign: "left",
    marginBottom: 20,
  },
  priceRow: {
    display: "flex",
    justifyContent: "space-between",
  },
  rp: {
    fontSize: 12,
    color: "#000",
    fontWeight: 700,
  },
  brand: {
    height: 230,
    overflowY: "scroll",
    "&::-webkit-scrollbar": {
      width: "0.4em",
    },
    "&::-webkit-scrollbar-track": {
      boxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
      webkitBoxShadow: "inset 0 0 6px rgba(0,0,0,0.00)",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  input: {
    width: "100%",
    height: 35,
    padding: "0px 10px",
    fontSize: "14px",
    color: "#fff",
    backgroundColor: theme.palette.primary.main,
  },
}));
export const PriceSlider = withStyles({
  thumb: {
    height: 20,
    width: 20,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -10,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 5,
    borderRadius: 4,
  },
  rail: {
    height: 5,
    borderRadius: 4,
  },
})(Slider);
